module.exports = __webpack_public_path__ + "img/Chthonic_Coin_Purse.7a138187.png";